import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import '../styles/style.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setBusy(true);
    try {
      const res = await api.post('/auth/forgot-password', { email });
      setMessage(res.data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="brand-panel">
        <div className="brand-glow" />
        <div className="brand-content">
          <div className="wordmark">HirePeaks</div>
          <div className="eyebrow">OFFER LETTER SYSTEM</div>
          <p className="tagline">
            Every offer, drafted and sent with the same care it took to earn it.
          </p>
        </div>
        <div className="brand-footer">Internal tool · Authorized staff only</div>
      </div>

      <div className="form-panel">
        <form className="login-card" onSubmit={handleSubmit} noValidate>
          <h1 className="login-title">Forgot password</h1>
          <p className="login-subtitle">Enter your email and we'll send you a reset link</p>

          {error && (
            <div className="error-box" role="alert">
              <ErrorIcon />
              <span>{error}</span>
            </div>
          )}

          {message && (
            <div className="success-box" role="status">
              <span>{message}</span>
            </div>
          )}

          <div className="field-group">
            <label className="field-label" htmlFor="fp-email">Email</label>
            <input
              id="fp-email"
              className="hp-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@hirepeaks.com"
              required
              autoFocus
              autoComplete="username"
            />
          </div>

          <button type="submit" disabled={busy} className="hp-submit">
            {busy ? (
              <>
                <span className="hp-spinner" aria-hidden="true" />
                Sending…
              </>
            ) : (
              'Send Reset Link'
            )}
          </button>

          <Link to="/login" className="back-to-login">
            ← Back to sign in
          </Link>
        </form>
      </div>
    </div>
  );
}

function ErrorIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
      <circle cx="10" cy="10" r="9" stroke="#C0362A" strokeWidth="1.6" />
      <line x1="10" y1="6" x2="10" y2="11" stroke="#C0362A" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="10" cy="14" r="1" fill="#C0362A" />
    </svg>
  );
}
